

// import { useEffect, useState, useCallback } from "react";
// import { toast } from "react-toastify";
// import { getSubscriptionDashboardApi } from "../../apis/subscriptionApi";

// export const useDashboardSubscriptions = () => {
//   const [dashboardData, setDashboardData] = useState({
//     subscription_overview: {
//       total_subscriptions: 0,
//       active_subscriptions: 0,
//       trial_subscriptions: 0,
//       expired_subscriptions: 0,
//       total_revenue: 0,
//     },
//     subscription_distribution: [],
//     revenue_trends: [],
//   });

//   const fetchDashboardData = useCallback(async (silent = false) => {
//     let toastId = null;
//     if (!silent) {
//       toastId = toast.loading("Loading subscription dashboard...");
//     }

//     try {
//       const data = await getSubscriptionDashboardApi();
//       if (data?.data) {
//         setDashboardData(data.data);

//         if (toastId) {
//           toast.update(toastId, {
//             render: "Dashboard updated",
//             type: "success",
//             isLoading: false,
//             autoClose: 1800,
//           });
//         }
//       }
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to load subscription dashboard";

//       if (toastId) {
//         toast.update(toastId, {
//           render: errorMessage,
//           type: "error",
//           isLoading: false,
//         });
//       } else {
//         toast.error(errorMessage);
//       }

//       console.error("Failed to fetch dashboard data:", err);
//     }
//   }, []);

//   useEffect(() => {
//     fetchDashboardData(true); // silent on initial load
//   }, [fetchDashboardData]);

//   // Optional: expose refetch method for manual refresh
//   const refetch = () => fetchDashboardData(false);

//   return { dashboardData, setDashboardData, refetch };
// };

import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { getSubscriptionDashboardApi } from "../../apis/subscriptionApi";

export const useDashboardSubscriptions = () => {
  const [dashboardData, setDashboardData] = useState({
    subscription_overview: {
      total_subscriptions: 0,
      active_subscriptions: 0,
      trial_subscriptions: 0,
      expired_subscriptions: 0,
      total_revenue: 0,
    },
    subscription_distribution: [],
    revenue_trends: [],
  });

  const [error, setError] = useState(null);

  const extractError = (err) => {
   // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to load subscription dashboard.",
    };
  };

  const fetchDashboardData = useCallback(async (silent = false) => {
    let toastId = null;
    if (!silent) {
      toastId = toast.loading("Loading subscription dashboard...");
    }

    try {
      const data = await getSubscriptionDashboardApi();

      if (data?.data) {
        setDashboardData(data.data);
      }

      if (toastId) {
        toast.update(toastId, {
          render: (
            <div>
              <strong>Dashboard Updated</strong>
              <div>Subscription dashboard loaded successfully.</div>
            </div>
          ),
          type: "success",
          isLoading: false,
          autoClose: 1800,
        });
      }
    } catch (err) {
      const { title, issue } = extractError(err);

      if (toastId) {
        toast.update(toastId, {
          render: (
            <div>
              <strong>{title}</strong>
              <div>{issue}</div>
            </div>
          ),
          type: "error",
          isLoading: false,
        });
      } else {
        toast.error(
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        );
      }

      setError({ title, issue });
      console.error("Failed to fetch dashboard data:", err);
    }
  }, []);

  useEffect(() => {
    fetchDashboardData(true);
  }, [fetchDashboardData]);

  const refetch = () => fetchDashboardData(false);

  return { dashboardData, setDashboardData, refetch, error };
};